import InteriorDesignForm from "../component/InteriorDesignForm";

const CorporateInteriorDesignCreate = () => {
  return <InteriorDesignForm isEditMode={false} />;
};

export default CorporateInteriorDesignCreate;
